import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps, CarouselItemViewModel, DataLayerProps {}
export default function CarouselMediumItem({
  link,
  desktopImageUrl,
  mobileImageUrl,
  title,
  isLazy,
  index,
  sortKey,
  componentId,
  id
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const handleClick = () => {
    sendCtaClickEvent({
      elementType: ComponentType.CarouselMedium,
      elementIndex: index ?? 0,
      itemID: id ?? '',
      elementName: sortKey,
      destinationUrl: link ?? '',
      componentId: componentId ?? '',
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselMedium,
      banner_name: sortKey ?? '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: componentId ?? '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  if (!mobileImageUrl || !title) return null;
  return <AppNextLink onClick={handleClick} href={link || ''} prefetch={false} aria-label={title} className='keen-slider__slide min-w-80 overflow-hidden rounded md:min-w-[992px] lg:min-w-[1200px]' data-sentry-element="AppNextLink" data-sentry-component="CarouselMediumItem" data-sentry-source-file="carousel-medium-item.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="carousel-medium-item.tsx">
                <source media='(min-width: 1024px)' srcSet={desktopImageUrl || ''} />

                <LazyImage src={mobileImageUrl} alt={title} className='w-full' loaderClassName='min-h-[200px] lg:min-h-[300px]' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="carousel-medium-item.tsx" />
            </picture>
        </AppNextLink>;
}